import { BOOOKSHOPPER_URL } from '../utils/constants'

const getCustomerOrders = async (dhcAddress) => {

  const response = await fetch(
    `${BOOOKSHOPPER_URL}/orders/byCustomer?address=${dhcAddress}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    }
  }
  )
  if (response.status === 400) {
    const { errors } = await response.json()
    return { errors }
  }
  return await response.json()
}

export default getCustomerOrders;
